import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';
import { StarsSkeleton } from '@ui/Stars';

import s from './ProductReview.sss';

interface Props {
  className?: string,
}

export const ProductReviewSkeleton: React.FC<Props> = ({
  className,
}) => (
  <article className={classNames(s.root, className)}>
    <header className={s.header}>
      <p className={s.username}>
        <Skeleton
          width="100px"
          height="14px"
        />
      </p>
      <p className={s.date}>
        <Skeleton
          width="65px"
          height="12px"
        />
      </p>
    </header>

    <StarsSkeleton className={s.rating} />

    <p className={s.comment}>
      <Skeleton
        width="80%"
        height="14px"
      />
      <Skeleton
        width="70%"
        height="14px"
      />
    </p>

    <ul className={s.photoList}>
      {[...Array(3)].map((_, i) => (
        <li
          key={i}
          className={s.photoItem}
        >
          <Skeleton
            width="72px"
            height="72px"
          />
        </li>
      ))}
    </ul>
  </article>
);
